import { ca } from '@cian/analytics';
// eslint-disable-next-line import/no-restricted-paths
import { EStatus } from '../../../node/repositories/newbuilding-card/entities/reviews/LikeSchema';
import { TAnalyticsUser, IProduct } from '../../types/analytics';

export type TAction = 'Click_sopr' | 'Show_sopr';
export type TCategory = 'Card_JK' | 'NewbuildingReviews';
export type TLabel =
  | 'Rating'
  | 'NewbuildingReviews'
  | 'All_Reviews'
  | 'Write'
  | 'Like'
  | 'Dislike'
  | 'Undo_Like'
  | 'Undo_Dislike'
  | 'read_more';

export type TPage = {
  pageType: string;
  siteType: string;
  extra: {
    type: string;
    rating?: number | null;
    review_id?: string;
  };
};

interface IProps {
  action: TAction;
  category: TCategory;
  label: TLabel;
  user: TAnalyticsUser;
  page: TPage;
  products: IProduct[];
}

export function getLabelFromState({ state, payload }: { state: EStatus; payload: EStatus }): TLabel {
  const map = {
    [EStatus.Disliked]: {
      [EStatus.Liked]: 'Like' as TLabel,
      [EStatus.Unknown]: 'Undo_Dislike' as TLabel,
      [EStatus.Disliked]: 'Dislike' as TLabel,
    },
    [EStatus.Liked]: {
      [EStatus.Disliked]: 'Dislike' as TLabel,
      [EStatus.Unknown]: 'Undo_Like' as TLabel,
      [EStatus.Liked]: 'Like' as TLabel,
    },
    [EStatus.Unknown]: {
      [EStatus.Disliked]: 'Dislike' as TLabel,
      [EStatus.Liked]: 'Like' as TLabel,
      [EStatus.Unknown]: 'Like' as TLabel,
    },
  };

  return map[state][payload];
}

export function trackNewbuildingReviewsAnalytic({ action, category, label, user, page, products }: IProps) {
  ca('eventSite', {
    name: 'oldevent',
    useLastProducts: true,
    action,
    category,
    label,
    user,
    page,
    products,
  });
}
